__webpack_require__.p = "/project-type-1/";